module.exports = __webpack_public_path__ + "static/casestudy-9431f8739f8a37438b8367e53da03305.png";